// permissionsHelper.ts

export type PermissionAction = 'create' | 'read' | 'update' | 'delete';

export const hasPermission = (resourceKey: string, action: PermissionAction): boolean => {
  try {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '{}');
    return permissions[resourceKey]?.includes(action) || false;
  } catch {
    return false;
  }
};
